/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedNotListedHeader_item = {|
  +isArt: ?boolean;
  +title: ?string;
  +categoryPath: ?string;
  +categoryPathItemCount: ?number;
  +creators: ?$ReadOnlyArray<?{|
    +creator: ?{|
      +name: ?string;
      +displayName: ?string;
      +urlTag: ?string;
      +publishedItemsCount: ?number;
    |};
  |}>;
  +classification: ?{|
    +creationDate: ?string;
  |};
  +categorNameLevel3: ?$ReadOnlyArray<?{|
    +name: ?string;
  |}>;
  +categorNameLevel2: ?$ReadOnlyArray<?{|
    +name: ?string;
  |}>;
  +vertical: ?"furniture" | "fashion" | "jewelry" | "art";
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedNotListedHeader_item",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isArt",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "title",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "categoryPath",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "categoryPathItemCount",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemCreator",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Creator",
          "name": "creator",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "displayName",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "urlTag",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "publishedItemsCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemClassification",
      "name": "classification",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "creationDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "categorNameLevel3",
      "args": [
        {
          "kind": "Literal",
          "name": "level",
          "value": 3,
          "type": "Int!"
        }
      ],
      "concreteType": "Category",
      "name": "getCategoriesByLevel",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": "getCategoriesByLevel{\"level\":3}"
    },
    {
      "kind": "LinkedField",
      "alias": "categorNameLevel2",
      "args": [
        {
          "kind": "Literal",
          "name": "level",
          "value": 2,
          "type": "Int!"
        }
      ],
      "concreteType": "Category",
      "name": "getCategoriesByLevel",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": "getCategoriesByLevel{\"level\":2}"
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "vertical",
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
